module.exports = __webpack_public_path__ + "img/111.9.405e6eda.png";